import React, { useState } from 'react'
import './Navbar.css'
import menu from '../../images/menu.svg'
import logo from '../../images/logo.svg'
import bookmark from '../../images/bookmark.svg'

const Navbar = () => {
  return (
    <div className={`navbar-container`}>
        <div className='navbar-div left'>
            <img src={menu} alt="menu-icon"  className='menu-icon' />
            <a href="https://www.zara.com/in/"><img src={logo} className='web-logo' alt="" /></a>
        </div>
        <div className='navbar-div right'>
            <div className='navbar-search-btn'><a href="https://www.zara.com/in/en/search">SEARCH</a></div>
            <div className='navbar-links'>
                <a href="https://www.zara.com/in/en/logon">LOG IN</a>
                <a href="https://www.zara.com/in/en/help">HELP</a>
            </div>
            <a href="https://www.zara.com/in/en/shop/cart">
              <div className='bookmark-div'>
                <img src={bookmark} alt="bookmark-icon"  className='bookmark-icon' />
                <span>0</span>
              </div>
            </a>
        </div>
    </div>
  )
}

export default Navbar